/* Model */
class RouteActionsConfigurationModel extends App.Models.BaseModel {
    modelUrl = 'RouteActionsConfiguration';
}

App.Models.RouteActionsConfiguration = RouteActionsConfigurationModel;

/* Collection */
class RouteActionsConfigurationCollection extends App.Collections.BaseCollection {
    url = 'RouteActionsConfiguration';
    model = App.Models.RouteActionsConfiguration;
}

App.Collections.RouteActionsConfigurations = RouteActionsConfigurationCollection;

/* Router */
class RouteActionsConfigurationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'RouteActionsConfiguration';
        const model = App.Models.RouteActionsConfiguration;
        const collectionClass = App.Collections.RouteActionsConfigurations;

        super(entityName, model, collectionClass);
    }
}

App.Routers.RouteActionsConfiguration = RouteActionsConfigurationRouter;
